export default __webpack_public_path__ + "static/media/SeyahatMasrafLimitTablosu2025.9b1952de.jpg";